import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import useSeo from "@/lib/useSeo";
import SizeGuideSection from "@/components/site/SizeGuide";
import ReviewsSection from "@/components/site/ReviewsSection";
import { Hero, HeroPicks, FirstOrderBanner, NavratriBanner, Categories, ProductGrid, Carousel, Occasions, Budgets, Promos, Inspiration, Trust, InstagramGrid, SectionHead } from "@/components/home/Sections";

const HERO_SLUGS = ["ivory-patchwork-mirror-work-navratri-chaniya-choli", "black-patchwork-mirror-work-navratri-chaniya-choli"];

export default function Home() {
  useSeo(null, null);
  const [best, setBest] = useState([]);
  const [fresh, setFresh] = useState([]);
  const [all, setAll] = useState([]);
  const [heroPicks, setHeroPicks] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { sort: "popularity", limit: 8 } }).then((r) => setBest(r.data));
    api.get("/products", { params: { tag: "new", sort: "newest", limit: 10 } }).then((r) => setFresh(r.data));
    api.get("/products", { params: { limit: 100 } }).then((r) => { setAll(r.data); setHeroPicks(HERO_SLUGS.map((s) => r.data.find((p) => p.slug === s)).filter(Boolean)); });
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <HeroPicks products={heroPicks} />
      <FirstOrderBanner />
      <NavratriBanner />
      <Categories />
      <section data-testid="best-sellers-section" className="kt-container pb-16 sm:pb-24">
        <SectionHead eyebrow="Most loved" title="Best Sellers" action={<Link to="/collections/best-sellers" data-testid="view-all-best-sellers" className="btn-outline">View All <ArrowRight className="h-4 w-4" /></Link>} />
        <ProductGrid products={best} testid="best-sellers-grid" />
      </section>
      <Trust />
      <section data-testid="new-arrivals-section" className="kt-container py-16 sm:py-24">
        <SectionHead eyebrow="Just landed" title="Fresh Styles for Your Wardrobe" action={<Link to="/collections/new-arrivals" data-testid="view-all-new-arrivals-button" className="btn-primary">View All New Arrivals <ArrowRight className="h-4 w-4" /></Link>} />
        <Carousel products={fresh} />
      </section>
      <Occasions />
      <Budgets />
      <Promos />
      <Inspiration />
      <div className="bg-[#F4EFEA]"><SizeGuideSection /></div>
      <ReviewsSection products={all} />
      <InstagramGrid />
    </div>
  );
}
